<template>
  <!-- 加價購與贈品共用 -->
  <b-modal
    id="AddBuyModal"
    ref="AddBuyModal"
    size="xl"
    modal-class="modal-style show-header"
    v-model="modal"
  >
    <template v-slot:modal-title>
      <h2 v-if="modalType === 'additionalPrice'">加價購</h2>
      <h2 v-if="modalType === 'freebies'">贈品</h2>
    </template>

    <template>
      <DetailListForModal :modalType="modalType">
        <SingleItemForModal
          v-for="item in discountItems"
          :key="item.product_id"
          :itemInfo="item"
          :modalType="modalType"
        />
      </DetailListForModal>
    </template>

    <template v-slot:modal-footer>
      <button class="custom-btn" @click="confirmToAdd">
        加入商品
      </button>
    </template>
  </b-modal>
</template>

<script>
import DetailListForModal from '@/components/CheckoutDetail/DetailListForModal';
import SingleItemForModal from '@/components/CheckoutDetail/SingleItemForModal';
import { mapState } from 'vuex';
import { cloneDeep } from 'lodash';

export default {
  props: {
    modalType: {
      type: String,
      default: ''
    }
  },
  components: {
    DetailListForModal,
    SingleItemForModal
  },
  data() {
    return {
      modal: false,
      addToCart: false
    };
  },
  computed: {
    ...mapState('order', ['discountItems', 'products'])
  },
  watch: {
    modal(val) {
      if (!val && this.addToCart) {
        this.addProduct();
      }
    }
  },
  methods: {
    showModal() {
      this.$refs.AddBuyModal.show();
      this.addToCart = false;
    },
    closeModal() {
      this.$bvModal.hide('AddBuyModal');
    },
    confirmToAdd() {
      this.$bvModal.hide('AddBuyModal');
      this.addToCart = true;
    },
    addProduct() {
      const addProducts = [];
      const removeProductIds = [];
      this.discountItems.forEach(item => {
        if (item.count > 0) {
          addProducts.push(cloneDeep(item));
        }
      });

      this.$store.dispatch('order/updateOrderDiscount', {
        type: this.modalType,
        addProducts,
        removeProductIds
      });
    }
  }
};
</script>
